import { createSlice } from "@reduxjs/toolkit";

interface GroupAssignmentData {
  selectedGroup: any;
  assignGroupData: AssignMetaData;
  artifactDetails: ArtifactDetailsMeta;
}

interface AssignMetaData {
  fixedDueDate: string | null;
  deltaDays: number | null;
  dueDateType: "DYNAMIC" | "STATIC" | "NA";
  autoEnrollment: boolean;
  autoRemoval: boolean;
  endDate: string | null;
  sendNotification: boolean;
  dueDateUnit: "DAY" | "MONTH" | "WEEK" | "YEAR" | null;
}

interface ArtifactDetailsMeta {
  artifactId: string;
  artifactType: string;
}

const INIT_STATE: GroupAssignmentData = {
  selectedGroup: {},
  assignGroupData: {
    fixedDueDate: null,
    deltaDays: 30,
    dueDateType: "DYNAMIC",
    autoEnrollment: false,
    autoRemoval: false,
    endDate: "",
    sendNotification: true,
    dueDateUnit: "DAY"
  },
  artifactDetails: {
    artifactId: "",
    artifactType: ""
  }
};

export const GroupAssignmentDataSlice = createSlice({
  name: "GroupAssignmentDataSlice",
  initialState: INIT_STATE,
  reducers: {
    setSelectedGroup(state, action) {
      state.selectedGroup = action.payload;
    },
    updateAssignData(state, action) {
      state.assignGroupData = action.payload;
    },
    updateArtifactDetails(state, action) {
      state.artifactDetails = action.payload;
    },
    resetAssignmentData(state) {
      state.assignGroupData = {
        fixedDueDate: null,
        deltaDays: 30,
        dueDateUnit: "DAY",
        dueDateType: "DYNAMIC",
        autoEnrollment: false,
        autoRemoval: false,
        endDate: null,
        sendNotification: true
      };
    },
    resetSelectedGroup(state) {
      state.selectedGroup = {};
    }
  }
});

export default GroupAssignmentDataSlice;

export const GroupAssignmentDataSliceActions = GroupAssignmentDataSlice.actions;
